import ActionsCell from "./ActionsCell";

export const getColumns = (setSelectedFreight, setOpenDeleteFreight) => [
  {
    field: "sn",
    headerName: "SN",
    width: 80,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      // console.log("testing freight data", params)
      const visibleSortedRows = params.api.getSortedRowIds?.();
      const index = visibleSortedRows?.indexOf(params.id);
      return index !== undefined ? index + 1 : "";
    },
  },
  {
    field: "freight_code",
    headerName: "Freight Code",
    width: 200,
  },
  {
    field: "added_date",
    headerName: "Added Date",
    width: 250,
  },
  {
    field: "added_by",
    headerName: "Added By",
    width: 200,
  },
  {
    field: "action",
    headerName: "Action",
    width: 200,
    sortable: false,
    renderCell: (params) => (
      <ActionsCell
        params={params}
        setSelectedFreight={setSelectedFreight}
        setOpenDeleteFreight={setOpenDeleteFreight}
      />
    ),
  },
];
